import type { ReactNode } from 'react';
import classNames from 'classnames';
import CheckCircleLarge from '@/shared/icons/flip-ui-kit/large/CheckCircle';
import InformationIconLarge from '@/shared/icons/flip-ui-kit/large/Information';
import KnifeIcon from '@/shared/icons/flip-ui-kit/large/Knife';
import WarningTriangleIconLarge from '@/shared/icons/flip-ui-kit/large/WarningTriangle';
import CheckCircleSmall from '@/shared/icons/flip-ui-kit/small/CheckCircle';
import InformationIconSmall from '@/shared/icons/flip-ui-kit/small/Information';
import Knife from '@/shared/icons/flip-ui-kit/small/Knife';
import WarningTriangleIconSmall from '@/shared/icons/flip-ui-kit/small/WarningTriangle';

const variants = (size: 'small' | 'large') => ({
  warning: {
    classes: ['bg-[#463719]', 'border-[#684C17]', 'text-cf-orange-1'],
    Icon: size === 'small' ? WarningTriangleIconSmall : WarningTriangleIconLarge,
  },
  info: {
    classes: ['bg-[#1C2F4A]', 'border-[#1C3E6F]', 'text-cf-blue-2'],
    Icon: size === 'small' ? InformationIconSmall : InformationIconLarge,
  },
  success: {
    classes: ['bg-[#254334]', 'border-[#2C6248]', 'text-cf-green-1'],
    Icon: size === 'small' ? CheckCircleSmall : CheckCircleLarge,
  },
  danger: {
    classes: ['bg-[#502626]', 'border-[#822222]', 'text-cf-red-1'],
    Icon: size === 'small' ? Knife : KnifeIcon,
  },
});

const Callout = ({
  type,
  children,
  size = 'large',
  fullWidth = false,
}: {
  type: keyof ReturnType<typeof variants>;
  children: ReactNode;
  size?: 'small' | 'large';
  fullWidth?: boolean;
}) => {
  const { classes, Icon } = variants(size)[type];

  return (
    <div
      className={classNames(
        'rounded-md border',
        ...classes,
        size === 'large' ? 'text-14' : 'text-12',
        fullWidth && 'w-full',
      )}
    >
      <div className="flex flex-row items-center space-x-2 px-2 py-3 font-aeonikMedium">
        <div>
          <Icon />
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Callout;
